module.exports = __webpack_public_path__ + "static/media/07-drag.d814afc8.png";